// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"796b7bbc","732":"8182f7bf"}[chunkId] + ".chunk.js";
};